export default "__VITE_ASSET__cda7283f__"